/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {internalTestBrazeEmailSubscription} from '../api'

export const useMutationInternalTestBrazeEmailSubscription = createReactQueryMutationHook('internalTestBrazeEmailSubscription', internalTestBrazeEmailSubscription)
